import PropTypes from 'prop-types';
import React from 'react';
/* CONTEXTS */
import { Provider as CommunityProvider } from '../../../contexts/CommunityContext';
import { buildImagePath } from '../../JobComponents/Company/Image/logo';
/* COMPONENTS */
import EmptyStates from '../EmptyStates/EmptyStates';
/* CONSTANTS */
import { EMPTY_STATES, LOADING_ANIMATION_URL, transform } from './constants';
/* STYLESHEET */
import './RenderController.scss';

export default class RenderController extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        /**
         * boolean to see if waiting for api response
         */
        isLoading: PropTypes.bool.isRequired,
        /**
         * array of network items
         */
        networkItems: PropTypes.array.isRequired,
        /**
         * optional custom css classname
         */
        className: PropTypes.string,
        /**
         * function to render a single item
         */
        renderSingleItem: PropTypes.func.isRequired,
        /**
         * enum of item type
         */
        itemType: PropTypes.oneOf([
            'pendingGroupRequests',
            'pendingRequests',
            'recommendedGroups',
            'recommendedUsers',
            'joinedGroups',
            'invitedUsers',
            'followedUsers',
            'connectedUsers',
        ]).isRequired,
        /**
         * enum location of MAIN (My Network) or SINGLE (Single Page)
         */
        location: PropTypes.oneOf(['MAIN', 'SINGLE', 'SINGLE_PAGE']),
    };

    static defaultProps = {
        location: 'MAIN',
        networkItems: [],
    };

    renderLoadingAnimation = () => {
        return (
            <div className="bg">
                <img
                    src={buildImagePath(
                        LOADING_ANIMATION_URL,
                        'animationWidth',
                        transform
                    )}
                />
            </div>
        );
    };

    render() {
        const {
            isLoading,
            networkItems,
            className,
            renderSingleItem,
            itemType,
            location,
        } = this.props;

        // If api is being called, show loading animation
        if (isLoading) {
            return this.renderLoadingAnimation();
        }

        // If done loading and there are items, render list
        if (networkItems.length > 0) {
            return (
                <CommunityProvider>
                    <ul className={className}>
                        {networkItems.map(renderSingleItem)}
                    </ul>
                </CommunityProvider>
            );
        }

        const { detail, networkCardType } = EMPTY_STATES[itemType];

        // If done loading and no items, show empty states
        return (
            <EmptyStates
                detail={detail}
                networkCardType={networkCardType}
                shouldShowImage={location === 'MAIN'}
            />
        );
    }
}
